module.exports = __webpack_public_path__ + "img/pink-bokeh.f3702955.jpg";